import Vue from 'vue'
import Vuetify from 'vuetify'
import './stylus/main.styl'
import * as firebase from 'firebase'
// import firebaseui from 'firebaseui'
import App from './App'
import router from './router'
import { store } from './store/store'
import mapBoard from '@/components/toolBox/mapBoard'
import Home from '@/components/Home'
import mB3 from '@/components/toolBox/mB3'
// import mB2 from '@/components/toolBox/mB2'
import schoolIndex from '@/components/toolBox/schoolIndex'
import pixelPicker from '@/components/toolBox/pixelPicker'
import timePicker from '@/components/toolBox/timePicker'
import AlertCmp from './components/Shared/Alert.vue'
import notSignedIn from './components/User/notSignedIn'
// import fireUI from './components/User/fireUI'
// import './components/Shared/config'

Vue.use(Vuetify, {
  theme: {
    five: '#7fa995', // 5
    ten: '#96c79d', // 10
    fifteen: '#b7ce98', // 15
    twenty: '#e2ba8b', // 20
    twentyfive: '#dfa38d', // 25
    thirty: '#cc8f91', // 30
    thirtyfive: '#7f7f7f',
    info: '#F0E9D8',
    deco: '#3388ff' // iconblue
  }
})
Vue.config.productionTip = true

Vue.component('not-signedin', notSignedIn)
Vue.component('Home', Home)
// Vue.component('fire-ui', fireUI)
// Vue.component('sign-up', () => import('./components/User/Signup.vue'))
Vue.component('school-index', () => import('./components/toolBox/schoolIndex.vue'))
Vue.component('app-alert', AlertCmp)
Vue.component('pixel-picker', () => import('./components/toolBox/pixelPicker.vue'))
Vue.component('time-picker', () => import('./components/toolBox/timePicker.vue'))
Vue.component('map-board', mapBoard)
Vue.component('m-b3', mB3)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyAMJTglwuIkeEdzOzQjZEOXUHkqeTWJFi0',
      authDomain: 'micropodvt.firebaseapp.com',
      databaseURL: 'https://micropodvt.firebaseio.com',
      projectId: 'micropodvt',
      storageBucket: 'micropodvt.appspot.com',
      messagingSenderId: '553621790602'
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        // this.$store.dispatch('fetchUserData')
      }
    })
    // this.$store.dispatch('loadCutouts')
  }
})



// WEBPACK FOOTER //
// ./src/main.js